import React from 'react'

function EventPage(){

    return (<>
    Event Page
    </>)
}

export default EventPage